export const NUMBER = 423;
export const NAME = `Quest card group cannot contain multiple cards`;
export const METADATA_ERROR = true;
export const DESCRIPTION = ``;

export const INVALID = [
`# Test Quest

  _text_

  Text

_text_

Text`,
];

export const VALID = [
`# Test Quest

_text_

Text`,
];
